// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectUnitLengthMeasurementsQueryResult, selectUnitLengthMeasurementsPageLoading, selectUnitLengthMeasurementsShowInitWaitingMessage} from '../_selectors/unit-length-measurement.selectors';

export class UnitLengthMeasurementsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectUnitLengthMeasurementsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectUnitLengthMeasurementsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectUnitLengthMeasurementsQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
